// Final ID - 139

export let bidiotvMoviesId = [
    {
        "id":25,
        "contents":58,
        "name": {
            "en": "Hollywood",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1001,
        name: '3 things James Gunn told \'GotG\' fans during his watch party',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/3-things-James-Gunn-told-GotG-fans-during-his-watch-party.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/3+things+James+Gunn+told+%60GotG\'+fans+during+his+watch+party.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1002,
        name: '5 Times Elle Fanning was a total red carpet princess',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/5-Times-Elle-Fanning-was-a-total-red-carpet-princess.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/5+Times+Elle+Fanning+was+a+total+red+carpet+princess.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1003,
        name: 'All the FBF you need of Victoria Beckham as Posh Spice',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All-the-FBF-you-need-of-Victoria-Beckham-as-Posh-Spice.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All+the+FBF+you+need+of+Victoria+Beckham+as+Posh+Spice.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1004,
        name: 'All the red carpets Anya Taylor-Joy came to slay',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All-the-red-carpets-Anya-Taylor-Joy-came-to-slay.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/All+the+red+carpets+Anya+Taylor-Joy+came+to+slay.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1005,
        name: 'Besides Ariana Grande, here are 5 stars Victoria Mone\'t wrote music for',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Besides-Ariana-Grande%2C-here-are-5-stars-Victoria-Mone\'t-wrote-music-for.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Besides+Ariana+Grande%2C+here+are+5+stars+Victoria+Mone\'t+wrote+music+for.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1006,
        name: 'Black Widow fans in the UK rejoicing over earlier release date',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Black-Widow-fans-in-the-UK-rejoicing-over-earlier-release-date.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Black+Widow+fans+in+the+UK+rejoicing+over+earlier+release+date.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1007,
        name: 'Cynthia Rowley gave birth to a Gen-Z Blair Waldorf',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Cynthia-Rowley-gave-birth-to-a-Gen-Z-Blair-Waldorf.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Cynthia+Rowley+gave+birth+to+a+Gen-Z+Blair+Waldorf.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1008,
        name: 'Disney reportedly in talks to release \'Black Widow\' straight to streaming',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Disney-reportedly-in-talks-to-release-\'Black-Widow\'-straight-to-streaming-copy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Disney+reportedly+in+talks+to+release+\'Black+Widow\'+straight+to+streaming.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1009,
        name: 'Drake, Nicki & Beyonce\' all drop surprise music',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Drake%2C-Nicki-%26-Beyonce\'-all-drop-surprise-music.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Drake%2C+Nicki+%26+Beyonce\'+all+drop+surprise+music.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1010,
        name: 'Fans watch sparks fly between JLo and Diddy in front of Arod',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Fans-watch-sparks-fly-between-JLo-and-Diddy-in-front-of-Arod.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Fans+watch+sparks+fly+between+JLo+and+Diddy+in+front+of+Arod.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1011,
        name: 'Five Fascinating facts about David Attenborough\'s life',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Five-Fascinating-facts-about-David-Attenborough\'s-life.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Five+Fascinating+facts+about+David+Attenborough\'s+life.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1012,
        name: 'Frank Ocean and Lindsay Lohan both make triumphant music comebacks',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Frank-Ocean-and-Lindsay-Lohan-both-make-triumphant-music-comebacks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Frank+Ocean+and+Lindsay+Lohan+both+make+triumphant+music+comebacks.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1013,
        name: 'From Australia to \'Hollywood\', Samara Weaving has arrived',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/From-Australia-to-\'Hollywood\'%2C-Samara-Weaving-has-arrived.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/From+Australia+to+\'Hollywood\'%2C+Samara+Weaving+has+arrived.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1014,
        name: 'George Clooney\'s top 3 OG movie roles',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/George-Clooney\'s-top-3-OG-movie-roles.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/George+Clooney\'s+top+3+OG+movie+roles.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1015,
        name: 'Meet the classically-trained actor who became Sex Education\'s biggest star',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet-the-classically-trained-actor-who-became-Sex-Education\'s-biggest-star.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet+the+classically-trained+actor+who+became+Sex+Education\'s+biggest+star.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1016,
        name: 'Gigi Hadid\'s mom Yolanda officially confirms the model\'s pregnancy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gigi-Hadid\'s-mom-Yolanda-officially-confirms-the-model\'s-pregnancy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gigi+Hadid\'s+mom+Yolanda+officially+confirms+the+model\'s+pregnancy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1017,
        name: 'Gwyneth Paltrow donates Oscar dress (she hates anyway) for Covid-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth-Paltrow-donates-Oscar-dress-(she-hates-anyway)-for-Covid-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth+Paltrow+donates+Oscar+dress+(she+hates+anyway)+for+Covid-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1018,
        name: 'Gwyneth Paltrow\'s socially distant party has nothing on these block parties',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth-Paltrow\'s-socially-distant-party-has-nothing-on-these-block-parties.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Gwyneth+Paltrow\'s+socially+distant+party+has+nothing+on+these+block+parties.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1019,
        name: 'Harry Styles in talks to play Boy George in biopic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Harry-Styles-in-talks-to-play-Boy-George-in-biopic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Harry+Styles+in+talks+to+play+Boy+George+in+biopic.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1020,
        name: 'Hayley Kiyoko\'s daily lounge outfits during corona are so relatable',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hayley-Kiyoko\'s-daily-lounge-outfits-during-corona-are-so-relatable.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hayley+Kiyoko\'s+daily+lounge+outfits+during+corona+are+so+relatable.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1021,
        name: 'He\'s got the biggest feet in the world & they\'re still growing',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/He\'s-got-the-biggest-feet-in-the-world-%26-they\'re-still-growing!.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/He\'s+got+the+biggest+feet+in+the+world+%26+they\'re+still+growing.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1022,
        name: 'Hollywood on Netflix Which characters were actually real',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hollywood-on-Netflix-Which-characters-were-actually-real.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Hollywood+on+Netflix+Which+characters+were+actually+real.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1023,
        name: 'How Hollywood got bit by \'Parasite\' star Park So-Dam',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Hollywood-got-bit-by-\'Parasite\'-star-Park-So-Dam.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Hollywood+got+bit+by+\'Parasite\'+star+Park+So-Dam.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1024,
        name: 'How Jackson Wang became China\'s golden boy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Jackson-Wang-became-China\'s-golden-boy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Jackson+Wang+became+China\'s+golden+boy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1025,
        name: 'How Peyton List went from Disney good-girl to Gen-Z beauty queen',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Peyton-List-went-from-Disney-good-girl-to-Gen-Z-beauty-queen.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Peyton+List+went+from+Disney+good-girl+to+Gen-Z+beauty+queen.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1026,
        name: 'How Victoria\'s Secret model Josephine Skriver is celebrating her 27th birthday',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How-Victoria\'s-Secret-model-Josephine-Skriver-is-celebrating-her-27th-birthday.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/How+Victoria\'s+Secret+model+Josephine+Skriver+is+celebrating+her+27th+birthday.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1027,
        name: 'If you haven\'t seen these 4 Audrey Hepburn films, you need a history class',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/If-you-haven\'t-seen-these-4-Audrey-Hepburn-films%2C-you-need-a-history-class.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/If+you+haven\'t+seen+these+4+Audrey+Hepburn+films%2C+you+need+a+history+class.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1028,
        name: 'It\'s a pop paradise with Ariana, Bieber, Hailee & Kim Petras',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/It\'s-a-pop-paradise-with-Ariana%2C-Bieber%2C-Hailee-%26-Kim-Petras.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/It\'s+a+pop+paradise+with+Ariana%2C+Bieber%2C+Hailee+%26+Kim+Petras.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1029,
        name: 'Jake Gyllenhaal admits he\'s gone full hipster & baking sourdough',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jake-Gyllenhaal-admits-he\'s-gone-full-hipster-%26-baking-sourdough.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jake+Gyllenhaal+admits+he\'s+gone+full+hipster+%26+baking+sourdough.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1030,
        name: 'Jane Fonda releases her own line of sweat suits perfect for quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jane-Fonda-releases-her-own-line-of-sweat-suits-perfect-for-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Jane+Fonda+releases+her+own+line+of+sweat+suits+perfect+for+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1031,
        name: 'Japan\'s having to watch sakura season pass them by & it sucks',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Japan\'s-having-to-watch-sakura-season-pass-them-by-%26-it-sucks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Japan\'s+having+to+watch+sakura+season+pass+them+by+%26+it+sucks.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1032,
        name: 'Justin Bieber reprimands Hailey in the most awkward Facebook Live',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Justin-Bieber-reprimands-Hailey-in-the-most-awkward-Facebook-Live.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Justin+Bieber+reprimands+Hailey+in+the+most+awkward+Facebook+Live.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1033,
        name: 'Lady Gaga jokes her next single is called \'Tim Cook\'',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Lady-Gaga-jokes-her-next-single-is-called-Tim-Cook.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Lady+Gaga+jokes+her+next+single+is+called+\'Tim+Cook\'.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1034,
        name: 'Logan Paul begs followers to buy his $90,000 couch',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Logan-Paul-begs-followers-to-buy-his-%2490%2C000-couch.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Logan+Paul+begs+followers+to+buy+his+%2490%2C000+couch.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1035,
        name: 'Marlo Kelly The mean girl from Dare Me who everyone loves',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Marlo-Kelly-The-mean-girl-from-Dare-Me-who-everyone-loves.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Marlo+Kelly+The+mean+girl+from+Dare+Me+who+everyone+loves.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1036,
        name: 'Meet the classically-trained actor who became Sex Education\'s biggest star',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet-the-classically-trained-actor-who-became-Sex-Education\'s-biggest-star.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Meet+the+classically-trained+actor+who+became+Sex+Education\'s+biggest+star.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1037,
        name: 'Miranda Kerr\'s 5 lessons in self-care',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Miranda-Kerr\'s-5-lessons-in-self-care.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Miranda+Kerr\'s+5+lessons+in+self-care.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1038,
        name: 'Newbies Chloe x Halle and Justine Skye blow everyone out the water',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Newbies-Chloe-x-Halle-%26amp%3B-Justine-Skye-blow-everyone-out-the-water.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Newbies+Chloe+x+Halle+%26amp%3B+Justine+Skye+blow+everyone+out+the+water.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1039,
        name: 'Patricia Arquette\'s 5 best on-screen roles you have to see',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Patricia-Arquette\'s-5-best-on-screen-roles-you-have-to-see.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Patricia+Arquette\'s+5+best+on-screen+roles+you+have+to+see.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1040,
        name: 'Power pop from Demi Lovato, Sam Smith and even Kelly Rowland',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Power-pop-from-Demi-Lovato%2C-Sam-Smith-and-even-Kelly-Rowland.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Power+pop+from+Demi+Lovato%2C+Sam+Smith+and+even+Kelly+Rowland.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1041,
        name: 'Quavo spends 29th birthday isolating & that\'s not a bad thing',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Quavo-spends-29th-birthday-isolating-%26-that\'s-not-a-bad-thing.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Quavo+spends+29th+birthday+isolating+%26+that\'s+not+a+bad+thing.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1042,
        name: 'Queen\'s legendary guitarist is ready to get \'preachy\' about veganism',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Queen\'s-legendary-guitarist-is-ready-to-get-\'preachy\'-about-veganism.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Queen\'s+legendary+guitarist+is+ready+to+get+\'preachy\'+about+veganism.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1043,
        name: 'Record Breakers This guy broke 3 records in parkour',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Record-Breakers-This-guy-broke-3-records-in-parkour.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Record+Breakers+This+guy+broke+3+records+in+parkour.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1044,
        name: 'Remember Rami Malek in Twilight and Gilmore Girls',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Remember-Rami-Malek-in-Twilight-and-Gilmore-Girls.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Remember+Rami+Malek+in+Twilight+and+Gilmore+Girls.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1045,
        name: 'Russia\'s LARPing scene through the eyes of an elf',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Russia\'s-LARPing-scene-through-the-eyes-of-an-elf.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Russia\'s+LARPing+scene+through+the+eyes+of+an+elf.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1046,
        name: 'Spencer Pratt to Lauren Conrad \'Those houses you own are because of me\'',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Spencer-Pratt-to-Lauren-Conrad-\'Those-houses-you-own-are-because-of-me.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Spencer+Pratt+to+Lauren+Conrad+\'Those+houses+you+own+are+because+of+me\'.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1047,
        name: 'Stella Maxwell has some majorly hot (and famous) exes',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Stella-Maxwell-has-some-majorly-hot-(and-famous)-exes.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Stella+Maxwell+has+some+majorly+hot+(and+famous)+exes.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1048,
        name: 'The 3 wildest revelations about Dennis Rodman in The Last Dance',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/The-3-wildest-revelations-about-Dennis-Rodman-in-The-Last-Dance.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/The+3+wildest+revelations+about+Dennis+Rodman+in+The+Last+Dance.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1049,
        name: 'This is exactly how long we need to wait for the Marvel movies',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/This-is-exactly-how-long-we-need-to-wait-for-the-Marvel-movies.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/This+is+exactly+how+long+we+need+to+wait+for+the+Marvel+movies.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1050,
        name: 'Three familiar faces we want to see in season 2 of The Mandalorian',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three-familiar-faces-we-want-to-see-in-season-2-of-The-Mandalorian.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three+familiar+faces+we+want+to+see+in+season+2+of+The+Mandalorian.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1051,
        name: 'Three Fun Facts about Mikey from Social House',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three-Fun-Facts-about-Mikey-from-Social-House.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Three+Fun+Facts+about+Mikey+from+Social+House.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1052,
        name: 'Travis Scott celebrates 28th with a Fortnite record & potential n 1',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Travis-Scott-celebrates-28th-with-a-Fortnite-record-%26-potential-n-1.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Travis+Scott+celebrates+28th+with+a+Fortnite+record+%26+potential+n+1.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1053,
        name: 'Trick Shot Talent- Javi\'s freestyle with a football is mesmerizing',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick-Shot-Talent--Javi\'s-freestyle-with-a-football-is-mesmerizing.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick+Shot+Talent-+Javi\'s+freestyle+with+a+football+is+mesmerizing.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1054,
        name: 'Trick Shot Talent- The 19-year-old self-made golfing extraordinaire',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick-Shot-Talent--The-19-year-old-self-made-golfing-extraordinaire.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Trick+Shot+Talent-+The+19-year-old+self-made+golfing+extraordinaire.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1055,
        name: 'What exactly has Chiara Ferragni been up to lately',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/What-exactly-has-Chiara-Ferragni-been-up-to-lately.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/What+exactly+has+Chiara+Ferragni+been+up+to+lately.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1056,
        name: 'Why are celebs getting naked during corona',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why-are-celebs-getting-naked-during-corona.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why+are+celebs+getting+naked+during+corona.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1057,
        name: 'Why fans are confused about Halsey\'s incredible `Little Mermaid\' performance',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why-fans-are-confused-about-Halsey\'s-incredible-%60Little-Mermaid\'-performance.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/Why+fans+are+confused+about+Halsey\'s+incredible+%60Little+Mermaid\'+performance.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1058,
        name: 'You\'ll never guess with whom Harry Potter would want to quarantine with',
        preview: 'https://cdn.mobiotv.com/bidiotv/Hollywood/You\'ll-never-guess-with-whom-Harry-Potter-would-want-to-quarantine-with.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Hollywood/You\'ll+never+guess+with+whom+Harry+Potter+would+want+to+quarantine+with.mp4',
        filename: '' } ]
    },
    {
        "id":29,
        "contents":32,
        "name": {
            "en": "Covid-19",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1120,
        name: 'A nurse\'s plea reveals they\'re dealing with more than you think',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/A-nurse-plea-reveals-they\'re-dealing-with-more-than-you-think.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/A+nurse\'s+plea+reveals+they\'re+dealing+with+more+than+you+think.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1121,
        name: 'Bill Gates knew the world wasn\'t ready for a pandemic back in 2015',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Bill-Gates-knew-the-world-wasn\'t-ready-for-a-pandemic-back-in-2015.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Bill+Gates+knew+the+world+wasn\'t+ready+for+a+pandemic+back+in+2015.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1122,
        name: 'Britney Spears coming out as a Socialist is the best plot twist of Covid-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Britney-Spears-coming-out-as-a-Socialist-is-the-best-plot-twist-of-Covid-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Britney+Spears+coming+out+as+a+Socialist+is+the+best+plot+twist+of+Covid-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1123,
        name: 'Can dogs be trained to detect COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Can-dogs-be-trained-to-detect-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Can+dogs+be+trained+to+detect+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1124,
        name: 'Cardi B\'s \'Coronavirus Rant Part 2\' has a new big warning',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi-B\'s-\'Coronavirus-Rant-Part-2\'-has-a-new-big-warning.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi+B\'s+\'Coronavirus+Rant+Part+2\'+has+a+new+big+warning.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1125,
        name: 'Cardi B\'s advice to graduates is actually really smart',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi-B\'s-advice-to-graduates-is-actually-really-smart.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Cardi+B\'s+advice+to+graduates+is+actually+really+smart.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1126,
        name: 'Chanel, Tommy, Armani... the whole luxury gang\'s here to fight COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chanel%2C-Tommy%2C-Armani...-the-whole-luxury-gang\'s-here-to-fight-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chanel%2C+Tommy%2C+Armani...+the+whole+luxury+gang\'s+here+to+fight+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1127,
        name: 'Chris Hemsworth will calm kids with guided meditations',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chris-Hemsworth-will-calm-kids-with-guided-meditations.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Chris+Hemsworth+will+calm+kids+with+guided+meditations.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1128,
        name: 'COVID-19 Weekly Recap Relaxed lockdowns, 4 million global cases and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19-Weekly-Recap-Relaxed-lockdowns%2C-4-million-global-cases-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19+Weekly+Recap+Relaxed+lockdowns%2C+4+million+global+cases+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1129,
        name: 'COVID-19 Weekly Recap Relaxed lockdowns, stimulus packages & more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19-Weekly-Recap-Relaxed-lockdowns%2C-stimulus-packages-%26-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/COVID-19+Weekly+Recap+Relaxed+lockdowns%2C+stimulus+packages+%26+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1130,
        name: 'Did you ever think these companies could help in a pandemic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Did-you-ever-think-these-companies-could-help-in-a-pandemic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Did+you+ever+think+these+companies+could+help+in+a+pandemic.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1131,
        name: 'Discrimination continues to spread globally alongside COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Discrimination-continues-to-spread-globally-alongside-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Discrimination+continues+to+spread+globally+alongside+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1132,
        name: 'Doing my part in the pandemic- A personal peek inside Italy\'s Red Cross',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing-my-part-in-the-pandemic-A-personal-peek-inside-Italy\'s-Red-Cross.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing+my+part+in+the+pandemic-+A+personal+peek+inside+Italy\'s+Red+Cross.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1133,
        name: 'Doing my part in the pandemic- Helping those without a home',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing-my-part-in-the-pandemic-Helping-those-without-a-home.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Doing+my+part+in+the+pandemic-+Helping+those+without+a+home.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1134,
        name: 'Dua Lipa doesn\'t think the world should go back to \'normal\'',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Dua-Lipa-doesn\'t-think-the-world-should-go-back-to-\'normal\'.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Dua+Lipa+doesn\'t+think+the+world+should+go+back+to+\'normal\'.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1135,
        name: 'Europe\'s homeless are going hungry amid COVID-19 lockdowns',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Europe\'s-homeless-are-going-hungry-amid-COVID-19-lockdowns.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Europe\'s+homeless+are+going+hungry+amid+COVID-19+lockdowns.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1136,
        name: 'Experts predict the next global crisis could be food shortages',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Experts-predict-the-next-global-crisis-could-be-food-shortages.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Experts+predict+the+next+global+crisis+could+be+food+shortages.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1137,
        name: 'Fake COVID-19 cures and treatments are getting out of hand',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Fake-COVID-19-cures-and-treatments-are-getting-out-of-hand.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Fake+COVID-19+cures+and+treatments+are+getting+out+of+hand.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1138,
        name: 'Five ways we\'re creating the perfect environment for viruses',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Five-ways-we\'re-creating-the-perfect-environment-for-viruses.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Five+ways+we\'re+creating+the+perfect+environment+for+viruses.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1139,
        name: 'Gaza\'s fearless four risking it all in the fight against COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Gaza\'s-fearless-four-risking-it-all-in-the-fight-against-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Gaza\'s+fearless+four+risking+it+all+in+the+fight+against+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1140,
        name: 'Here\'s how countries are prepping for tourism after COVID-19',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s-how-countries-are-prepping-for-tourism-after-COVID-19.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s+how+countries+are+prepping+for+tourism+after+COVID-19.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1141,
        name: 'Here\'s what astronauts can teach us about self-isolation',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s-what-astronauts-can-teach-us-about-self-isolation.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Here\'s+what+astronauts+can+teach+us+about+self-isolation.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1142,
        name: 'How to stay safe while grocery shopping during a pandemic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/How-to-stay-safe-while-grocery-shopping-during-a-pandemic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/How+to+stay+safe+while+grocery+shopping+during+a+pandemic.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1143,
        name: 'Kylie Jenner using Kylie Skin factory to donate hand sanitizers',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Kylie-Jenner-using-Kylie-Skin-factory-to-donate-hand-sanitizers.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Kylie+Jenner+using+Kylie+Skin+factory+to+donate+hand+sanitizers.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1144,
        name: 'Martha Stewart gives out strict beauty rules for quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Martha-Stewart-gives-out-strict-beauty-rules-for-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Martha+Stewart+gives+out+strict+beauty+rules+for+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1145,
        name: 'The artists inspiring people to wear face masks in Gaza',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/The-artists-inspiring-people-to-wear-face-masks-in-Gaza.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/The+artists+inspiring+people+to+wear+face+masks+in+Gaza.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1146,
        name: 'The race to find a COVID-19 vaccine is ramping up',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Three-apps-being-used-to-stop-COVID-19-in-its-tracks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/The+race+to+find+a+COVID-19+vaccine+is+ramping+up.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1147,
        name: 'Three apps being used to stop COVID-19 in its tracks',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Three-apps-being-used-to-stop-COVID-19-in-its-tracks.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Three+apps+being+used+to+stop+COVID-19+in+its+tracks.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1148,
        name: 'Twenty One Pilots & Liam Payne drop first music from quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Twenty-One-Pilots-%26-Liam-Payne-drop-first-music-from-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Twenty+One+Pilots+%26+Liam+Payne+drop+first+music+from+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1149,
        name: 'Viruses & diseases don\'t stand a chance against the UVD Robot',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Viruses-%26-diseases-don\'t-stand-a-chance-against-the-UVD-Robot.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Viruses+%26+diseases+don\'t+stand+a+chance+against+the+UVD+Robot.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1150,
        name: 'Would you expose yourself to COVID-19 to help find a vaccine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Would-you-expose-yourself-to-COVID-19-to-help-find-a-vaccine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/Would+you+expose+yourself+to+COVID-19+to+help+find+a+vaccine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1151,
        name: 'You have to see Blue Ivy\'s adorable PSA to wash your hands',
        preview: 'https://cdn.mobiotv.com/bidiotv/Covid-19/You-have-to-see-Blue-Ivy\'s-adorable-PSA-to-wash-your-hands.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Covid-19/You+have+to+see+Blue+Ivy\'s+adorable+PSA+to+wash+your+hands.mp4',
        filename: '' } ]
    },
    {
        "id":28,
        "contents":12,
        "name": {
            "en": "Entertainment",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1120,
        name: 'Are you of the 1.7 million who downloaded Quibi',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Are-you-of-the-1.7-million-who-downloaded-Quibi.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Are+you+of+the+1.7+million+who+downloaded+Quibi.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1121,
        name: 'Cleaning up beaches and creating art, one butt at a time',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Cleaning-up-beaches-and-creating-art%2C-one-butt-at-a-time.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Cleaning+up+beaches+and+creating+art%2C+one+butt+at+a+time.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1122,
        name: 'Five Fun facts about Mean Girls Broadway star Sabrina Carpenter',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Five-Fun-facts-about-Mean-Girls-Broadway-star-Sabrina-Carpenter.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Five+Fun+facts+about+Mean+Girls+Broadway+star+Sabrina+Carpenter.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1123,
        name: 'How to photo transfer anything A wooden gift for mom',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-photo-transfer-anything-A-wooden-gift-for-mom.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+photo+transfer+anything+A+wooden+gift+for+mom.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1124,
        name: 'How to Photo Transfer Anything Images on rocks made easy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-Photo-Transfer-Anything-Images-on-rocks-made-easy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+Photo+Transfer+Anything+Images+on+rocks+made+easy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1125,
        name: 'How to Photo Transfer Anything Screen printing made easy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How-to-Photo-Transfer-Anything-Screen-printing-made-easy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/How+to+Photo+Transfer+Anything+Screen+printing+made+easy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1126,
        name: 'One man\'s mission to get the wheels turning in Colombia',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/One-man\'s-mission-to-get-the-wheels-turning-in-Colombia.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/One+man\'s+mission+to+get+the+wheels+turning+in+Colombia.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1127,
        name: 'Online Life How these creatives are staying inspired during lockdown',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-these-creatives-are-staying-inspired-during-lockdown.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-these-creatives-are-staying-inspired-during-lockdown.jpg',
        filename: '' },
      { duration: 'Watch Now',
        id: 1128,
        name: 'Online Life How this dancer\'s turning adversity into opportunity',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-How-this-dancer\'s-turning-adversity-into-opportunity.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+How+this+dancer\'s+turning+adversity+into+opportunity.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1129,
        name: 'Online Life Tips from a teacher who\'s gone digital during lockdown',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online-Life-Tips-from-a-teacher-who\'s-gone-digital-during-lockdown.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Online+Life+Tips+from+a+teacher+who\'s+gone+digital+during+lockdown.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1130,
        name: 'Seth Rogen\'s 5 most comforting comedies to watch now',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Seth-Rogen\'s-5-most-comforting-comedies-to-watch-now.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/Seth+Rogen\'s+5+most+comforting+comedies+to+watch+now.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1131,
        name: 'The Zoom blind dating service all singles should know about',
        preview: 'https://cdn.mobiotv.com/bidiotv/Entertainment/The-Zoom-blind-dating-service-all-singles-should-know-about.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Entertainment/The+Zoom+blind+dating+service+all+singles+should+know+about.mp4',
        filename: '' } ]
    },
    {
        "id":37,
        "contents":5,
        "name": {
            "en": "Adventure",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1051,
        name: 'Bucket list opportunity- Siberian ice rafting is 100% unique',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/Bucket-list-opportunity-Siberian-ice-rafting-is-100%25-unique.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/Bucket+list+opportunity-+Siberian+ice+rafting+is+100%25+unique.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1052,
        name: 'Muniellos One of the most exclusive forests in the world',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/Muniellos-One-of-the-most-exclusive-forests-in-the-world.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/Muniellos+One+of+the+most+exclusive+forests+in+the+world.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1053,
        name: 'The fascinating investigation findings after the Titanic sank',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/The-fascinating-investigation-findings-after-the-Titanic-sank.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/The+fascinating+investigation+findings+after+the+Titanic+sank.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1054,
        name: 'This 85-year-old grandma games harder than people half her age',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/This-85-year-old-grandma-games-harder-than-people-half-her-age.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/This+85-year-old+grandma+games+harder+than+people+half+her+age.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1055,
        name: 'With this e-bike, you can cycle on water',
        preview: 'https://cdn.mobiotv.com/bidiotv/Adventure/With-this-e-bike%2C-you-can-cycle-on-water.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Adventure/With+this+e-bike%2C+you+can+cycle+on+water.mp4',
        filename: '' },
        ]        
    },
    {
        "id":30,
        "contents":6,
        "name": {
            "en": "Health",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1200,
        name: 'Level up your fitness and relationship with these acroyoga moves',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Level-up-your-fitness-and-relationship-with-these-acroyoga-moves.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Level+up+your+fitness+and+relationship+with+these+acroyoga+moves.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1201,
        name: 'Life Boost Influencers- Roz the diva will make you sweat and smile',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Life-Boost-Influencers--Roz-the-diva-will-make-you-sweat-and-smile.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Life+Boost+Influencers-+Roz+the+diva+will+make+you+sweat+and+smile.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1202,
        name: 'Life Boost Influencers- The ASMR-tist helping quarantined fans relax',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Life-Boost-Influencers--The-ASMR-tist-helping-quarantined-fans-relax.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Life+Boost+Influencers-+The+ASMR-tist+helping+quarantined+fans+relax.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1203,
        name: 'Shay Mitchell is quarantining just like us- with wine and a yoga mat',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/Shay-Mitchell-is-quarantining-just-like-us-with-wine-and-a-yoga-mat.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/Shay+Mitchell+is+quarantining+just+like+us-+with+wine+and+a+yoga+mat.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1204,
        name: 'The Colombian prison that lets inmates get a taste of freedom and nature',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/The-Colombian-prison-that-lets-inmates-get-a-taste-of-freedom-and-nature.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/The+Colombian+prison+that+lets+inmates+get+a+taste+of+freedom+and+nature.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1205,
        name: 'TV doctors have a video message for real doctors',
        preview: 'https://cdn.mobiotv.com/bidiotv/Health/TV-doctors-have-a-video-message-for-real-doctors.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Health/TV+doctors+have+a+video+message+for+real+doctors.mp4',
        filename: '' } ]
    },
    {
        "id":31,
        "contents":5,
        "name": {
            "en": "Cooking",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1208,
        name: 'All the recipes Gigi & Bella Hadid have cooked in quarantine',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/All-the-recipes-Gigi-%26-Bella-Hadid-have-cooked-in-quarantine.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/All+the+recipes+Gigi+%26+Bella+Hadid+have+cooked+in+quarantine.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1209,
        name: 'Craving something sweet Make a \'Sugar Bomb\' milkshake',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Make-a-\'Sugar-Bomb\'-milkshake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Make+a+\'Sugar+Bomb\'+milkshake.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1210,
        name: 'Craving something sweet Try making this rainbow pudding shake',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Try-making-this-rainbow-pudding-shake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Try+making+this+rainbow+pudding+shake.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1211,
        name: 'Craving something sweet Try making this strawberry milkshake',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Try-making-this-strawberry-milkshake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Try+making+this+strawberry+milkshake.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1212,
        name: 'Craving something sweet Try making this yummy Oreo milkshake!',
        preview: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving-something-sweet-Try-making-this-yummy-Oreo-milkshake.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Cooking/Craving+something+sweet+Try+making+this+yummy+Oreo+milkshake!.mp4',
        filename: '' } ]
    },
    {
        "id":27,
        "contents":19,
        "name": {
            "en": "Sports and Gaming",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1120,
        name: 'Esports - Can the industry save a country\'s economy',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports---Can-the-industry-save-a-country\'s-economy.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+-+Can+the+industry+save+a+country\'s+economy.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1121,
        name: 'Esports news Dreamhack, Twitch, Sinatraa and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-Dreamhack%2C-Twitch%2C-Sinatraa-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+Dreamhack%2C+Twitch%2C+Sinatraa+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1122,
        name: 'Esports news LDLC, Rocket League, BBC and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-LDLC%2C-Rocket-League%2C-BBC-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+LDLC%2C+Rocket+League%2C+BBC+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1123,
        name: 'Esports news LEC Winners, TSM, FPX and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-LEC-Winners%2C-TSM%2C-FPX-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+LEC+Winners%2C+TSM%2C+FPX+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1124,
        name: 'Esports news Poke\'mon, ESL One, Popular events and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports-news-Poke\'mon%2C-ESL-One%2C-Popular-events-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Esports+news+Poke\'mon%2C+ESL+One%2C+Popular+events+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1125,
        name: 'Gaming Industry Updates EVO, Summer Game Fest, GDC and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates-EVO%2C-Summer-Game-Fest%2C-GDC-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates+EVO%2C+Summer+Game+Fest%2C+GDC+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1126,
        name: 'Gaming Industry Updates Germany, Travis Scott, LoL MSI and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates-Germany%2C-Travis-Scott%2C-LoL-MSI-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates+Germany%2C+Travis+Scott%2C+LoL+MSI+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1127,
        name: 'Gaming Industry Updates Ubisoft, Switch, Capcom and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates-Ubisoft%2C-Switch%2C-Capcom-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates+Ubisoft%2C+Switch%2C+Capcom+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1128,
        name: 'Gaming Industry Updates- Microsoft, Playstation, big budgets & more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-Industry-Updates--Microsoft%2C-Playstation%2C-big-budgets-%26-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming+Industry+Updates-+Microsoft%2C+Playstation%2C+big+budgets+%26+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1129,
        name: 'Gaming- LEC Spring, Gamescom and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming--LEC-Spring%2C-Gamescom-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Gaming-+LEC+Spring%2C+Gamescom+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1130,
        name: 'Mobile gaming news Crash Bandicoot, Legends of Runeterra and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-gaming-news-Crash-Bandicoot%2C-Legends-of-Runeterra-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+gaming+news+Crash+Bandicoot%2C+Legends+of+Runeterra+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1131,
        name: 'Mobile gaming news Red Dot, Spongebob, Sonic and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-gaming-news-Red-Dot%2C-Spongebob%2C-Sonic-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+gaming+news+Red+Dot%2C+Spongebob%2C+Sonic+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1132,
        name: 'Mobile Gaming News Surviving Titan, Endurance and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-Gaming-News-Surviving-Titan%2C-Endurance-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+Gaming+News+Surviving+Titan%2C+Endurance+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1133,
        name: 'Mobile gaming news- Rebel Cops, Grid Autosport and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-gaming-news--Rebel-Cops%2C-Grid-Autosport-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+gaming+news-+Rebel+Cops%2C+Grid+Autosport+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1134,
        name: 'Mobile Gaming News- Valorant, Forza Street and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile-Gaming-News--Valorant%2C-Forza-Street-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Mobile+Gaming+News-+Valorant%2C+Forza+Street+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1135,
        name: 'Remarkable Gamers- Esports pro Ant1ka is taking CS-GO by storm',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Remarkable-Gamers--Esports-pro-Ant1ka-is-taking-CS-GO-by-storm.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/Remarkable+Gamers-+Esports+pro+Ant1ka+is+taking+CS-GO+by+storm.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1136,
        name: 'This Week in Gaming Assassin\'s Creed, Battlefield, Stadia and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This-Week-in-Gaming-Assassin\'s-Creed%2C-Battlefield%2C-Stadia-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This+Week+in+Gaming+Assassin\'s+Creed%2C+Battlefield%2C+Stadia+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1137,
        name: 'This Week in Gaming Eco Sims, Apex Legends, Star Wars and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This-Week-in-Gaming-Eco-Sims%2C-Apex-Legends%2C-Star-Wars-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This+Week+in+Gaming+Eco+Sims%2C+Apex+Legends%2C+Star+Wars+and+more.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1138,
        name: 'This Week in Gaming PS5 graphics, F1 2020, Twitch and more',
        preview: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This-Week-in-Gaming-PS5-graphics%2C-F1-2020%2C-Twitch-and-more.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Sports+%26+Gaming/This+Week+in+Gaming+PS5+graphics%2C+F1+2020%2C+Twitch+and+more.mp4',
        filename: '' } ]
    },
    {
        "id":32,
        "contents":4,
        "name": {
            "en": "Animal",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'How are countries dealing with rising domestic violence cases',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/How-are-countries-dealing-with-rising-domestic-violence-cases.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/How+are+countries+dealing+with+rising+domestic+violence+cases.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1214,
        name: 'My Dream Job- A dash of bow tie dapperness for shelter dogs',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/My-Dream-Job-A-dash-of-bow-tie-dapperness-for-shelter-dogs.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/My+Dream+Job-+A+dash+of+bow+tie+dapperness+for+shelter+dogs.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1215,
        name: 'Pets with Professions- Max was elected Mayor of a city... and he\'s a dog',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/Pets-with-Professions-Max-was-elected-Mayor-of-a-city...-and-he\'s-a-dog.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/Pets+with+Professions-+Max+was+elected+Mayor+of+a+city...+and+he\'s+a+dog.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1216,
        name: 'This dog\'s got skills when it comes to stuffing tennis balls in his mouth',
        preview: 'https://cdn.mobiotv.com/bidiotv/Animals/This-dog\'s-got-skills-when-it-comes-to-stuffing-tennis-balls-in-his-mouth.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Animals/This+dog\'s+got+skills+when+it+comes+to+stuffing+tennis+balls+in+his+mouth.mp4',
        filename: '' } ]
    },
    {
        "id":33,
        "contents":2,
        "name": {
            "en": "Ancient",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'Beng-Mealea-An-ancient-temple-reclaimed-by-nature',
        preview: 'https://cdn.mobiotv.com/bidiotv/Ancient/Beng-Mealea-An-ancient-temple-reclaimed-by-nature.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Ancient/Beng+Mealea+An+ancient+temple+reclaimed+by+nature.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1214,
        name: 'These countries should be really proud of their leaders right now',
        preview: 'https://cdn.mobiotv.com/bidiotv/Ancient/These-countries-should-be-really-proud-of-their-leaders-right-now.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Ancient/These+countries+should+be+really+proud+of+their+leaders+right+now.mp4',
        filename: '' } ]
    },
    {
        "id":34,
        "contents":4,
        "name": {
            "en": "Business",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'Are they hiring 5 industries doing better than ever before',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/Are-they-hiring-5-industries-doing-better-than-ever-before.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/Are+they+hiring+5+industries+doing+better+than+ever+before.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1214,
        name: 'How the West Bank took a mask shortage into their own hands',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/How-the-West-Bank-took-a-mask-shortage-into-their-own-hands.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/How+the+West+Bank+took+a+mask+shortage+into+their+own+hands.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1215,
        name: 'University students are filing lawsuits over tuition fees',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/University-students-are-filing-lawsuits-over-tuition-fees.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/University+students+are+filing+lawsuits+over+tuition+fees.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1216,
        name: '"Why the ""5G Conspiracy"" is harmful and making some men money"',
        preview: 'https://cdn.mobiotv.com/bidiotv/Business/Why-the-%225G-Conspiracy%22-is-harmful-(and-making-some-men-money).jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Business/Why+the+%225G+Conspiracy%22+is+harmful+and+making+some+men+money.mp4',
        filename: '' } ]
    },
    {
        "id":35,
        "contents":2,
        "name": {
            "en": "Beat The Heat",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'Beat the heat with blue lagoon cocktail popsicles',
        preview: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat-the-heat-with-blue-lagoon-cocktail-popsicles.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat+the+heat+with+blue+lagoon+cocktail+popsicles.mp4',
        filename: '' },
      { duration: 'Watch Now',
        id: 1214,
        name: 'Beat the heat with cuervo sangria popsicles',
        preview: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat-the-heat-with-cuervo-sangria-popsicles.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Beat+the+Heat/Beat+the+heat+with+cuervo+sangria+popsicles.mp4',
        filename: '' } ]
    },
    {
        "id":36,
        "contents":1,
        "name": {
            "en": "Morality",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'Could humanity be one cyber suit away from immortality',
        preview: 'https://cdn.mobiotv.com/bidiotv/Morality/Could-humanity-be-one-cyber-suit-away-from-immortality.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Morality/Could+humanity+be+one+cyber+suit+away+from+immortality.mp4',
        filename: '' } ]
    },
    {
        "id":37,
        "contents":1,
        "name": {
            "en": "Racing",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'Mercedes F1 ditches races for life-saving medical devices',
        preview: 'https://cdn.mobiotv.com/bidiotv/Racing/Mercedes-F1-ditches-races-for-life-saving-medical-devices.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Racing/Mercedes+F1+ditches+races+for+life-saving+medical+devices.mp4',
        filename: '' } ]
    },
    {
        "id":38,
        "contents":1,
        "name": {
            "en": "Science",
        },
        "videos": [ { duration: 'Watch Now',
        id: 1213,
        name: 'Scientists have \'engineered\' an enzyme that devours plastic',
        preview: 'https://cdn.mobiotv.com/bidiotv/Science/Scientists-have-\'engineered\'-an-enzyme-that-devours-plastic.jpg',
        desc: '',
        videoUrl: 'https://cdn.mobiotv.com/bidiotv/Science/Scientists+have+\'engineered\'+an+enzyme+that+devours+plastic.mp4',
        filename: '' },
       ]
    },
    {
        "id": 1,
        "contents": 24,
        "name": {
            "en": "Inspirasi hidup",
            "be": "Inspirasi hidup",
            "id": "Inspirasi hidup"
        },
        "videos": [
            {
                "duration": "00:03:15",
                "id": 820,
                "name": "Bagaimana Aku Menghadapi Perang dengan Puisi",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Bagaimana+Aku+Menghadapi+Perang+dengan+Puisi.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Bagaimana+Aku+Menghadapi+Perang+dengan+Puisi.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 821,
                "name": "CEO Cilik Melintasi Batas dengan Bahasa",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/CEO+Cilik+Melintasi+Batas+dengan+Bahasa.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/CEO+Cilik+Melintasi+Batas+dengan+Bahasa.mp4",
                "filename":"",
            },
            // {
            //     "duration": "00:03:15",
            //     "id": 822,
            //     "name": "Jilbab Tidak Menghentikan Saya Menjadi Petarung Muay Thai",
            //     "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Jilbab+Tidak+Menghentikan+Saya+Menjadi+Petarung+Muay+Thai.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Jilbab+Tidak+Menghentikan+Saya+Menjadi+Petarung+Muay+Thai.mp4",
            //     "filename":"",
            // },
            // {
            //     "duration": "00:03:15",
            //     "id": 823,
            //     "name": "Menjaga Kehidupan Monster Air",
            //     "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Menjaga+Kehidupan+Monster+Air.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Menjaga+Kehidupan+Monster+Air.mp4",
            //     "filename":"",
            // },
            // {
            //     "duration": "00:03:15",
            //     "id": 824,
            //     "name": "Menyulap Sampah Menjadi Peluang",
            //     "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Menyulap+Sampah+Menjadi+Peluang.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Menyulap+Sampah+Menjadi+Peluang.mp4",
            //     "filename":"",
            // },
            {
                "duration": "00:03:15",
                "id": 825,
                "name": "Putar Balik Stereotip Geng Imigran dengan Tujuan yang Baik",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Putar+Balik+Stereotip+Geng+Imigran+dengan+Tujuan+yang+Baik.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Putar+Balik+Stereotip+Geng+Imigran+dengan+Tujuan+yang+Baik.mp4",
                "filename":"",
            },
            {
                "id": 989,
                "category": "Inspirasi Hidup",
                "name": "Bertuah! Kesempatan Belajar Kedua",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Bertuah!+Kesempatan+Belajar+Kedua.mp4",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Bertuah!+Kesempatan+Belajar+Kedua.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 990,
                "category": "Inspirasi Hidup",
                "name": "Inspirasi Arfa Shahid Untuk Mencintai Diri Sendiri",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Inspirasi+Arfa+Shahid+Untuk+Mencintai+Diri+Sendiri.mp4",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Inspirasi+Arfa+Shahid+Untuk+Mencintai+Diri+Sendiri.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 991,
                "category": "Inspirasi Hidup",
                "name": "Penyelamat Lebah di Kota Berlin",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Penyelamat+Lebah+di+Kota+Berlin.mp4",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Penyelamat+Lebah+di+Kota+Berlin.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 992,
                "category": "Inspirasi Hidup",
                "name": "Semangat Melestarikan Sisi Liar Shanghai",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Semangat+Melestarikan+Sisi+Liar+Shanghai.mp4",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Semangat+Melestarikan+Sisi+Liar+Shanghai.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 993,
                "category": "Inspirasi Hidup",
                "name": "Seni Make-up Jadi Karya",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Seni+Make-up+Jadi+Karya.mp4",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Seni+Make-up+Jadi+Karya.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 994,
                "category": "Inspirasi Hidup",
                "name": "Si Cilik Jadi CEO Raja Daur Ulang Plastik",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/inspirasihidup/Si+Cilik+Jadi+CEO+Raja+Daur+Ulang+Plastik.mp4",
                "preview": "https://cdn.mobiotv.com/id/inspirasihidup/Si+Cilik+Jadi+CEO+Raja+Daur+Ulang+Plastik.jpg",
                "filename": "",
                "desc": ""
              }
        ]
    },
    {
        "id": 2,
        "contents": 24,
        "name": {
            "en": "Gaya Hidup",
            "be": "Gaya Hidup",
            "id": "Gaya Hidup"
        },
        "videos": [
            {
                "duration": "00:03:15",
                "id": 813,
                "name": "Apakah Uji Coba Penghasilan Dasar Universal Finlandia Bekerja",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Apakah+Uji+Coba+Penghasilan+Dasar+Universal+Finlandia+Bekerja.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Apakah+Uji+Coba+Penghasilan+Dasar+Universal+Finlandia+Bekerja.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 815,
                "name": "Lima Fakta Mengejutkan tentang Cristiano Ronaldo",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Lima+Fakta+Mengejutkan+tentang+Cristiano+Ronaldo.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Lima+Fakta+Mengejutkan+tentang+Cristiano+Ronaldo.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 816,
                "name": "Lima Momen Lucu Bayi Chicago West",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Lima+Momen+Lucu+Bayi+Chicago+West.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Lima+Momen+Lucu+Bayi+Chicago+West.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 818,
                "name": "Siapa Aktivis Muda yang Berjuang untuk Iklim Kita",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Siapa+Aktivis+Muda+yang+Berjuang+untuk+Iklim+Kita.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Siapa+Aktivis+Muda+yang+Berjuang+untuk+Iklim+Kita.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 819,
                "name": "Tempat Perlindungan Gigi untuk Anak-anak",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Tempat+Perlindungan+Gigi+untuk+Anak-anak.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Tempat+Perlindungan+Gigi+untuk+Anak-anak.mp4",
                "filename":"",
            },
            {
                "id": 982,
                "category": "Gaya Hidup",
                "name": "Penampilan Sempurna di Kota Oleh Insta-Model",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Penampilan+Sempurna+di+Kota+Oleh+Insta-Model.mp4",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Penampilan+Sempurna+di+Kota+Oleh+Insta-Model.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 983,
                "category": "Gaya Hidup",
                "name": "Stereotypes Hip Hop Melawan Vandalisme",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Stereotypes+Hip+Hop+Melawan+Vandalisme.mp4",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Stereotypes+Hip+Hop+Melawan+Vandalisme.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 984,
                "category": "Gaya Hidup",
                "name": "Tua-tua Keladi Yang Kini Bahagia",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gayahidup/Tua-tua+Keladi+Yang+Kini+Bahagia.mp4",
                "preview": "https://cdn.mobiotv.com/id/gayahidup/Tua-tua+Keladi+Yang+Kini+Bahagia.jpg",
                "filename": "",
                "desc": ""
              }
        ]
    },
    {
        "id": 3,
        "contents": 24,
        "name": {
            "en": "Documents",
            "be": "Documents",
            "id": "Dokumenter"
        },
        "videos": [
            {
                "duration": "00:02:35",
                "id": 602,
                "name": "Bersihkan Ciliwung Tiap Minggu",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Bersihkan+Ciliwung+Tiap+Minggu.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Bersihkan+Ciliwung+Tiap+Minggu.mp4",
                "filename":"",
            },
            {
                "duration": "00:01:17",
                "id": 603,
                "name": "Cara Membuat Slime Galaksi yang Licin dan Lengket",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Cara+Membuat+Slime+Galaksi+yang+Licin+dan+Lengket.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Cara+Membuat+Slime+Galaksi+yang+Licin+dan+Lengket.mp4",
                "filename":"",
            },
            {
                "duration": "00:01:05",
                "id": 605,
                "name": "Haruskah Indonesia Mengakihiri Perang Terhadap Narkoba",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Haruskah+Indonesia+Mengakihiri+Perang+Terhadap+Narkoba.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Haruskah+Indonesia+Mengakihiri+Perang+Terhadap+Narkoba.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:44",
                "id": 606,
                "name": "Kehilangan Anggota Tubuh Tidak Menghentikan Mimpinya",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Kehilangan+Anggota+Tubuh+Tidak+Menghentikan+Mimpinya.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Kehilangan+Anggota+Tubuh+Tidak+Menghentikan+Mimpinya.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:13",
                "id": 607,
                "name": "Kembalinya Sang Bambu Jawaban Sejak Dahulu Kala",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Kembalinya+Sang+Bambu+Jawaban+Sejak+Dahulu+Kala.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Kembalinya+Sang+Bambu+Jawaban+Sejak+Dahulu+Kala.mp4",
                "filename":"",
            },
            {
                "duration": "00:01:51",
                "id": 608,
                "name": "Ketika Satu Tidak Cukup Aplikasi Poligami Indonesia",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Ketika+Satu+Tidak+Cukup+Aplikasi+Poligami+Indonesia.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Ketika+Satu+Tidak+Cukup+Aplikasi+Poligami+Indonesia.mp4",
                "filename":"",
            },
            // {
            //     "duration": "00:04:24",
            //     "id": 609,
            //     "name": "Mata Palsu untuk Anak Indonesia ",
            //     "preview": "https://cdn.mobiotv.com/id/dokumenter/Mata+Palsu+untuk+Anak+Indonesia.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Mata+Palsu+untuk+Anak+Indonesia.mp4",
            //     "filename":"",
            // },
            // {
            //     "duration": "00:02:40",
            //     "id": 700,
            //     "name": "Mengkritik Lewat Lelehan Lilin",
            //     "preview": "https://cdn.mobiotv.com/id/dokumenter/Mengkritik+Lewat+Lelehan+Lilin.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Mengkritik+Lewat+Lelehan+Lilin.mp4",
            //     "filename":"",
            // },
            {
                "duration": "00:02:53",
                "id": 701,
                "name": "Plastik Nabati Tanpa Polusi Siap Menguasi Dunia!",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Plastik+Nabati+Tanpa+Polusi+Siap+Menguasi+Dunia!.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Plastik+Nabati+Tanpa+Polusi+Siap+Menguasi+Dunia!.mp4",
                "filename":"",
            },
            // {
            //     "duration": "00:04:17",
            //     "id": 702,
            //     "name": "Rumah Baru Membantu Orang-orang yang Terbengkalai",
            //     "preview": "https://cdn.mobiotv.com/id/dokumenter/Rumah+Baru+Membantu+Orang-orang+yang+Terbengkalai.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Rumah+Baru+Membantu+Orang-orang+yang+Terbengkalai.mp4",
            //     "filename":"",
            // },
            // {
            //     "duration": "00:03:01",
            //     "id": 703,
            //     "name": "Rumahku Istanaku Penyelamat Bayi Prematur",
            //     "preview": "https://cdn.mobiotv.com/id/dokumenter/Rumahku+Istanaku+Penyelamat+Bayi+Prematur.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Rumahku+Istanaku+Penyelamat+Bayi+Prematur.mp4",
            //     "filename":"",
            // },
           /* {
                "duration": "00:03:21",
                "id": 704,
                "name": "Selamatkan Korban Topeng Monyet",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Selamatkan+Korban+Topeng+Monyet.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Selamatkan+Korban+Topeng+Monyet.mp4",
                "filename":"",
            },*/
            {
                "duration": "00:01:40",
                "id": 705,
                "name": "Si Sok Pintar DIY Bola Anti Stres",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Si+Sok+Pintar+DIY+Bola+Anti+Stres.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Si+Sok+Pintar+DIY+Bola+Anti+Stres.mp4"                ,
                "filename":"",
            },
            {
                "id": 975,
                "category": "Dokumentar",
                "name": "Akupuntur untuk Dokter Hewan?",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Akupuntur+untuk+Dokter+Hewan%3F.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Akupuntur+untuk+Dokter+Hewan%3F.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 976,
                "category": "Dokumentar",
                "name": "Alborz Heydaryan - Bisakah Membayangkan Realitasmu?",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Alborz+Heydaryan+-+Bisakah+Membayangkan+Realitasmu%3F.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Alborz+Heydaryan+-+Bisakah+Membayangkan+Realitasmu%3F.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 977,
                "category": "Dokumentar",
                "name": "Daur Ulang Peledak",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Daur+Ulang+Peledak.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Daur+Ulang+Peledak.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 978,
                "category": "Dokumentar",
                "name": "Desa Mati Dibangkitkan Semula",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Desa+Mati+Dibangkitkan+Semula.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Desa+Mati+Dibangkitkan+Semula.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 979,
                "category": "Dokumentar",
                "name": "Linelife Express - Terselamat Dari Kereta Api Tercepat di India",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Linelife+Express+-+Terselamat+Dari+Kereta+Api+Tercepat+di+India.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Linelife+Express+-+Terselamat+Dari+Kereta+Api+Tercepat+di+India.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 980,
                "category": "Dokumentar",
                "name": "Menganyam Kehidupan Tuju Kehamilan Yang Aman",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Menganyam+Kehidupan+Tuju+Kehamilan+Yang+Aman.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Menganyam+Kehidupan+Tuju+Kehamilan+Yang+Aman.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 981,
                "category": "Dokumentar",
                "name": "Minuman Baru dari Jus Kecoak?",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/dokumenter/Minuman+Baru+dari+Jus+Kecoak%3F.mp4",
                "preview": "https://cdn.mobiotv.com/id/dokumenter/Minuman+Baru+dari+Jus+Kecoak%3F.jpg",
                "filename": "",
                "desc": ""
              }
        ],
        
    },
    {
        "id": 4,
        "contents": 24,
        "name": {
            "en": "Travel",
            "be": "Travel",
            "id": "Perjalanan" 
        },
        "videos": [
            {
                "duration": "00:03:15",
                "id": 828,
                "name": "Pondok Persembunyian Tradisional Airbnb",
                "preview": "https://cdn.mobiotv.com/id/perjalanan/Pondok+Persembunyian+Tradisional+Airbnb.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/perjalanan/Pondok+Persembunyian+Tradisional+Airbnb.mp4",
                "filename":""
            },
            {
                "duration": "00:02:57",
                "id": 501,
                "name": "Menganyam Menuju Kehamilan yang Lebih Aman",
                "preview": "https://cdn.mobiotv.com/id/perjalanan/Menganyam+Menuju+Kehamilan+yang+Lebih+Aman.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/perjalanan/Menganyam+Menuju+Kehamilan+yang+Lebih+Aman.mp4",
                "filename":"",
            },
            {
                "duration": "00:01:22",
                "id": 502,
                "name": "Mewah atau Hemat Mahal dan Murahnya Liburan ke Hong Kong",
                "preview": "https://cdn.mobiotv.com/id/perjalanan/Mewah+atau+Hemat+Mahal+dan+Murahnya+Liburan+ke+Hong+Kong.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/perjalanan/Mewah+atau+Hemat+Mahal+dan+Murahnya+Liburan+ke+Hong+Kong.mp4",
                "filename":"",
            },
            {
                "duration": "00:01:54",
                "id": 504,
                "name": "Perempuan ini Hidup Bersama 1.500 Tarantalu",
                "preview": "https://cdn.mobiotv.com/id/perjalanan/Perempuan+ini+Hidup+Bersama+1.500+Tarantalu.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/perjalanan/Perempuan+ini+Hidup+Bersama+1.500+Tarantalu.mp4",
                "filename":"",
            },
            {
                "id": 995,
                "category": "Perjalanan",
                "name": "Ayuh! Liburan ke Palermo",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/perjalanan/Ayuh!+Liburan+ke+Palermo.mp4",
                "preview": "https://cdn.mobiotv.com/id/perjalanan/Ayuh!+Liburan+ke+Palermo.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 996,
                "category": "Perjalanan",
                "name": "Pembalap Snowboard Es",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/perjalanan/Pembalap+Snowboard+Es.mp4",
                "preview": "https://cdn.mobiotv.com/id/perjalanan/Pembalap+Snowboard+Es.jpg",
                "filename": "",
                "desc": ""
              }
        ]
    },
    {
        "id": 5,
        "contents": 24,
        "name": {
            "en": "Tips DIY",
            "be": "Tips DIY",
            "id": "Tips DIY"
        },
        "videos": [
            {
                "duration": "00:03:15",
                "id": 833,
                "name": "Menghilangkan Gelisah dengan Balon",
                "preview": "https://cdn.mobiotv.com/id/tipsdiy/Menghilangkan+Gelisah+dengan+Balon.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/tipsdiy/Menghilangkan+Gelisah+dengan+Balon.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 834,
                "name": "Plastik Seseorang, Tempat Lilin Orang Lain",
                "preview": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Lilin+Orang+Lain.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Lilin+Orang+Lain.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 835,
                "name": "Plastik Seseorang, Tempat Penyimpan Ponsel Orang Lain",
                "preview": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Penyimpan+Ponsel+Orang+Lain.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Penyimpan+Ponsel+Orang+Lain.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 836,
                "name": "Plastik Seseorang, Tempat Penyimpanan Orang Lain",
                "preview": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Penyimpanan+Orang+Lain.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Penyimpanan+Orang+Lain.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 837,
                "name": "Plastik Seseorang, Tempat Tisu Orang Lain",
                "preview": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Tisu+Orang+Lain.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/tipsdiy/Plastik+Seseorang%2C+Tempat+Tisu+Orang+Lain.mp4",
                "filename":"",
            }
        ]
    },
    {
        "id": 6,
        "contents": 24,
        "name": {
            "en": "Extreme",
            "be": "Extreme",
            "id": "Game Ekstrim"
        },
        "videos": [
            {
                "duration": "00:01:20",
                "id": 506,
                "name": "Bagaimana Cosplay Mengubah Hidup Saya",
                "preview": "https://cdn.mobiotv.com/id/gameekstrim/Saya+Merasa+Seperti+Orang+Lain+Ketika+Melakukan+Cosplay.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gameekstrim/Saya+Merasa+Seperti+Orang+Lain+Ketika+Melakukan+Cosplay.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:43",
                "id": 507,
                "name": "Jika Selamat, Saya Akan Ubah Hidup Saya dan Jalani Segalanya Sebaik Mungkin",
                "preview": "https://cdn.mobiotv.com/id/gameekstrim/Jika+Selamat%2C+Saya+Akan+Ubah+Hidup+Saya+dan+Jalani+Segalanya+Sebaik+Mungkin.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gameekstrim/Jika+Selamat%2C+Saya+Akan+Ubah+Hidup+Saya+dan+Jalani+Segalanya+Sebaik+Mungkin.mp4",
                "filename":"",
            },
            // {
            //     "duration": "00:03:34",
            //     "id": 508,
            //     "name": "Jilbab Tidak Menghentikan Saya Menjadi Petarung Muay Thai",
            //     "preview": "https://cdn.mobiotv.com/id/gameekstrim/Jilbab+Tidak+Menghentikan+Saya+Menjadi+Petarung+Muay+Thai.jpg",
            //     "desc": "",
            //     "videoUrl": "https://cdn.mobiotv.com/id/gameekstrim/Jilbab+Tidak+Menghentikan+Saya+Menjadi+Petarung+Muay+Thai.mp4",
            //     "filename":"",
            // },
            {
                "duration": "00:03:57",
                "id": 509,
                "name": "Pembalap Snowboard Melambung di Antara Pegunungan Es",
                "preview": "https://cdn.mobiotv.com/id/gameekstrim/Pembalap+Snowboard+Melambung+di+Antara+Pegunungan+Es.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gameekstrim/Pembalap+Snowboard+Melambung+di+Antara+Pegunungan+Es.mp4"                ,
                "filename":"",
            },
            {
                "duration": "00:03:01",
                "id": 600,
                "name": "Saya Merasa Seperti Orang Lain Ketika Melakukan Cosplay",
                "preview": "https://cdn.mobiotv.com/id/gameekstrim/Saya+Merasa+Seperti+Orang+Lain+Ketika+Melakukan+Cosplay.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/gameekstrim/Saya+Merasa+Seperti+Orang+Lain+Ketika+Melakukan+Cosplay.mp4",
                "filename":"",
            },
            
        ]
    },
    {
        "id": 7,
        "contents": 24,
        "name": {
            "en": "Teknologi",
            "be": "Teknologi",
            "id": "Teknologi"
        },
        "videos": [
          
            {
                "duration": "00:03:15",
                "id": 829,
                "name": "Alat Sensor Pemberi Harapan",
                "preview": "https://cdn.mobiotv.com/id/teknologi/Alat+Sensor+Pemberi+Harapan.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/teknologi/Alat+Sensor+Pemberi+Harapan.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 831,
                "name": "Tidak Lama Lagi Kamu Bisa Mengisi Ponsel Melalui WiFi",
                "preview": "https://cdn.mobiotv.com/id/teknologi/Tidak+Lama+Lagi+Kamu+Bisa+Mengisi+Ponsel+Melalui+WiFi.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/teknologi/Tidak+Lama+Lagi+Kamu+Bisa+Mengisi+Ponsel+Melalui+WiFi.mp4",
                "filename":"",
            },
            {
                "duration": "00:03:15",
                "id": 832,
                "name": "Tiga Cara untuk Menghindari Pencuri Identitas Online",
                "preview": "https://cdn.mobiotv.com/id/teknologi/Tiga+Cara+untuk+Menghindari+Pencuri+Identitas+Online.jpg",
                "desc": "",
                "videoUrl": "https://cdn.mobiotv.com/id/teknologi/Tiga+Cara+untuk+Menghindari+Pencuri+Identitas+Online.mp4",
                "filename":"",
            },
            {
                "id": 997,
                "category": "Teknologi",
                "name": "Antisosial Bukan Punca Bermain Game",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/teknologi/Antisosial+Bukan+Punca+Bermain+Game.mp4",
                "preview": "https://cdn.mobiotv.com/id/teknologi/Antisosial+Bukan+Punca+Bermain+Game.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 998,
                "category": "Teknologi",
                "name": "Ironman China Robot Masa Depan",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/teknologi/Ironman+China+Robot+Masa+Depan.mp4",
                "preview": "https://cdn.mobiotv.com/id/teknologi/Ironman+China+Robot+Masa+Depan.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 999,
                "category": "Teknologi",
                "name": "Taman Hiburan Nintendo",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/teknologi/Taman+Hiburan+Nintendo.mp4",
                "preview": "https://cdn.mobiotv.com/id/teknologi/Taman+Hiburan+Nintendo.jpg",
                "filename": "",
                "desc": ""
              }
        ]
    },
    {
        "id": 8,
        "contents": 4,
        "name": {
            "en": "Hiburan Selebrititas",
            "be": "Hiburan Selebrititas",
            "id": "Hiburan Selebrititas"
        },
        "videos": [
            {
                "id": 985,
                "category": "Hiburan Selebrititas",
                "name": "Aktor Hollywood Noah Jupe",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/hiburanselebrititas/Aktor+Hollywood+Noah+Jupe.mp4",
                "preview": "https://cdn.mobiotv.com/id/hiburanselebrititas/Aktor+Hollywood+Noah+Jupe.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 986,
                "category": "Hiburan Selebrititas",
                "name": "Karl Lagerfeld Menderita Kanker",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/hiburanselebrititas/Karl+Lagerfeld+Menderita+Kanker.mp4",
                "preview": "https://cdn.mobiotv.com/id/hiburanselebrititas/Karl+Lagerfeld+Menderita+Kanker.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 987,
                "category": "Hiburan Selebrititas",
                "name": "Karpet Merah Grammy yang Paling Hebat",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/hiburanselebrititas/Karpet+Merah+Grammy+yang+Paling+Hebat.mp4",
                "preview": "https://cdn.mobiotv.com/id/hiburanselebrititas/Karpet+Merah+Grammy+yang+Paling+Hebat.jpg",
                "filename": "",
                "desc": ""
              },
              {
                "id": 988,
                "category": "Hiburan Selebrititas",
                "name": "Ulang Tahun Ikonis John Travolta",
                "duration": "",
                "videoUrl": "https://cdn.mobiotv.com/id/hiburanselebrititas/Ulang+Tahun+Ikonis+John+Travolta.mp4",
                "preview": "https://cdn.mobiotv.com/id/hiburanselebrititas/Ulang+Tahun+Ikonis+John+Travolta.jpg",
                "filename": "",
                "desc": ""
              }
        ]
    }
];


// WEBPACK FOOTER //
// ./src/constants/bidiotvmovies_id.js